import React, { FC } from "react";

import { Store } from "components/Store";

const StorePage: FC = () => {
  return <Store />;
};

export default StorePage;
